export const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "https://uatapigxp.genxai.com/api";
// export const API_BASE_URL = 'https://uatapigxp.genxai.com/api';
export const SOCKET_URL = process.env.REACT_APP_SOCKET_URL || "https://uatapigxp.genxai.com/hubs/notifications";
export const API_ENDPOINTS = {
  LOGIN: "/Accounts/login",
  FORGOT_PASSWORD: "/Accounts/forgot-password",
  CHANGE_PASSWORD: "/Accounts/ChangePassword",
  RESET_PASSWORD: "/Accounts/RestPassword",
  GET_MENU: "/Accounts/getmenu",
  REFRESH_TOKEN: "/Accounts/refresh",
  LOGOUT: "/Accounts/logout",

  // user endpoints
  // chat endpoints
  GET_USE_CASES: "/UserUseCase/GetUseCaseListForUser",
  START_CHAT: "/ChatBot/Start1",
  GET_CHAT_HISTORY: "/ChatBot/History/me",
  GET_CHAT_HISTORIES: "/ChatBot/History",
  GET_CHAT_MESSAGES: "/ChatBot/Messages/",
  SEND_MESSAGE: "/ChatAgentAI/AskAgent",
  PIN_CHAT: "/ChatBot/PinChat",
  DELETE_CHAT: "/ChatBot/DeleteChat",
  RENAME_CHAT: "/ChatBot/RenameChat",
  ARCHIVE_CHAT: "/ChatBot/ArchiveChat",
  SHARE_CHAT: "/ChatBot/ShareChat",
  GET_SHARED_CHATS: "/ChatBot/GetSharedChat",
  UPDATE_CHAT_MODEL: "/ChatBot/UpdateConversationModelGroup",

  // admin endpoints
  // overview endpoints
  GET_OVERVIEW: "/AdminDashBoard/getAdminDashBoardData",
  DOWNLOAD_TENANT_DEMOGRAPHICS_REPORT: "/AdminDashBoard/downloadTenantDemographicsReport",
  // for users
  GET_USERS: "/Users/getallusers",
  CREATE_USER: "/Users/InsertUserMaster ",
  UPDATE_USER: "/Users/updateuser",
  GET_BY_ID_USER: "/Users/getuserbyid",
  DELETE_USER: "/Users/deleteuser",

  // group endpoints
  GET_GROUPS: "/UserGroup/getallUserGroups",
  CREATE_GROUP: "/UserGroup/InsertUserGroup",
  GET_BY_ID_GROUP: "/UserGroup/getUserGroupbyId",
  DELETE_GROUP: "/UserGroup/deleteUserGroup",
  UPDATE_GROUP: "/UserGroup/UpdateUserGroup",

  // company endpoints
  GET_COMPANIES: "/Company/AllCompanies",
  CREATE_COMPANY: "/Company/CreateProfile",
  DELETE_COMPANY: "/Company/DeleteCompany",
  GET_BY_ID_COMPANY: "/Company/GetById",
  UPDATE_COMPANY: "/Company/UpdateCompany",

  // model congiguration endpoints
  GET_ALL_AGENTS: "/ModelConfig/GetAllAgents",
  UPDATE_MODEL_CONFIG: "/ModelConfig/UpdateModelGroupWithAgents",
  CREATE_MODEL_CONFIG: "/ModelConfig/CreateModelGroupWithAgents",
  GET_AGENT_CONFIGS_BY_MODEL_GROUP: "/ModelConfig/GetAgentConfigsByModelGroup",
  DELETE_MODEL_CONFIG: "/ModelConfig/DeleteModelGroup",
  GET_ADDED_MODELS: "/ModelConfig/GetModelGroupByCompanyId",

  // SQLConfiguration endpoints
  GET_SQL_DBTYPE: "/SQLConfiguration/databasetype",
  GET_DB: "/SQLConfiguration/getdatabase",
  GET_DB_INFO: "/SQLConfiguration/databaseinfo",
  GET_CONNECTION_STRING: "/SQLConfiguration/GetConnectionString",
  GET_SQL_CONFIG_BY_COMPANY: "/SQLConfiguration/GetSQLConfigByCompanyId",
  SAVE_SQL_CONFIG: "/SQLConfiguration/SaveCompanySQLConfigs",
  UPDATE_SQL_CONFIG: "/SQLConfiguration/UpdateCompanySQLConfigs",

  // Screen Management endpoints
  CREATE_SCREEN: "/Screen/InsertScreen",
  UPDATE_SCREEN: "/Screen/UpdateScreen",
  GET_SCREENS: "/Screen/GetScreens",
  GET_SCREEN_BY_ID: "/Screen/GetById",
  DELETE_SCREEN: "/Screen/DeleteScreen",

  // upload files manually
  SAVE_FILE_ANALYTICS: "/FileConfiguration/SaveCompanyFileConfigs",
  UPDATE_FILE_ANALYTICS: "/FileConfiguration/UpdateFileConfig",
  GET_FILE_ANALYTICS_BY_ID:
    "/FileConfiguration/GetFileConfigurationByCompanyID",
  DELETE_FILE_ANALYTICS: "/FileConfiguration/DeleteFileConfig",

  // upload file from cloud
  GET_CLOUD_FILE_STORAGE_TYPE: "/FileConfiguration/GetStorageType",
  INSERT_AWS_S3_FILE_STORAGE_CONFIG:
    "/FileConfiguration/InsertAwsS3StorageConfig",
  INSERT_AZURE_FILE_STORAGE_CONFIG:
    "/FileConfiguration/InsertAzureStorageConfig",
  INSERT_SFTP_FILE_STORAGE_CONFIG: "/FileConfiguration/InsertSftpStorageConfig",
  GET_AWS_S3_FILE_LIST: "/FileConfiguration/fileslistforS3",
  GET_AZURE_FILE_LIST: "/FileConfiguration/fileslistforAzure",
  GET_SFTP_FILE_LIST: "/FileConfiguration/fileslistforSftp",
  // GET_CLOUD_FOLDERS_AND_TEST_CONNECTION: '/FileConfiguration/test-connection',
  // GET_CLOUD_FILE_LIST: '/FileConfiguration/list-files',
  SAVE_CLOUD_FILE: "/FileConfiguration/save-or-update-cloud-files",
  UPDATE_CLOUD_FILE: "/FileConfiguration/update-cloud-files",

  // media endpoints
  UPLOAD_MEDIA: "/MediaConfiguration/UploadMediaConfig", 
  GET_ALL_MEDIA: "/MediaFiles/GetAllMediaConfig",
  GET_MEDIA_BY_COMPANY_ID: "/MediaConfiguration/GetMediaConfigurationByCompanyId",
  DELETE_MEDIA_FILE: "/MediaConfiguration/DeleteMediaConfig",
  UPDATE_MEDIA_FILE: "/MediaConfiguration/UpdateMediaConfig",

  // ML endpoints
  ML_UPLOAD_DATASET: "/ML/UploadDataSet",
  ML_GET_ALL_DATASETS_BY_COMPANY_ID: "/ML/GetAllDataSetsByCompanyId",
  ML_DELETE_DATASET_BY_ID: "/ML/DeleteDataSetById",
  ML_SAVE_MODEL: "/ML/SaveMLModel",
  ML_BUILD_MODEL: "/ML/BuildMLModel",
  ML_GET_ALL_MODEL_TYPES: "/ML/GetAllMLModelTypes",
  ML_GET_ALL_MODELS_BY_COMPANY_ID: "/ML/GetAllMLModelsByCompanyId",
  ML_DELETE_MODEL_BY_ID: "/ML/DeleteMLModelById",
  ML_TEST_MODEL: "/ML/TestMLModel",

  // Data seeding endpoints
  START_DB_SEED: "/DataSeeding/start-db-seed",
  START_PDF_SEED: "/DataSeeding/start-pdf-seed",
  START_MEDIA_SEED: "/DataSeeding/start-media-seed",

  // Authorization endpoints
  SAVE_ROLE_SCREEN_MAPPING: "/UserAuthorization/SaveRoleScreens",
  GET_ROLE_SCREEN_MAPPING: "/UserAuthorization/GetRoleScreens",

  // Notification endpoints
  GET_NOTIFICATION: "/Notification/unread",
  MARK_AS_READ: "/Notification/read",
  // workspaces endpoints
  GET_WORKSPACE: "/UseCase/GetUseCaseListForCompany",
  INSERT_WORKSPACE: "/UseCase/InsertCompanyUseCase",
  DELETE_WORKSPACE: "/UseCase/DeleteCompanyUseCase",
  UPDATE_WORKSPACE: "/UseCase/UpdateCompanyUseCase",
  SQL_AND_FILE_CONFIG: "/UseCase/SQLandFileConfigByCompanyID",
  GET_FIELDS_BY_TABLE_NAME: "/UseCase/GetSelectedTableFields",
  GET_BY_ID: "/UseCase/GetUsecaseDataById",

  // UserUseCase endpoints
  USER_USECASE_DATA: "/UserUseCase/UseCaseData",
  USER_USECASE_GET_BY_ID: "/UserUseCase/GetUsecaseUserById",
  USER_USECASE_UPDATE: "/UserUseCase/UpdateUseCaseForUser",
  USER_USECASE_DELETE: "/UserUseCase/DeleteUseCaseForUser",
  USER_USECASE_LIST_FOR_USER: "/UserUseCase/GetUseCaseListForUser",
  USER_USECASE_INSERT: "/UserUseCase/InsertUserUseCase",

  // UserModelGroupMapping endpoints
  GET_USER_MODEL_GROUP_MAPPINGS_BY_USER:
    "/UserModelGroup/GetUserModelGroupMappingsByUser",
  CREATE_USER_MODEL_GROUP_MAPPING:
    "/UserModelGroup/CreateUserModelGroupMapping",
  UPDATE_USER_MODEL_GROUP_MAPPING:
    "/UserModelGroup/UpdateUserModelGroupMapping",
  DELETE_USER_MODEL_GROUP_MAPPING:
    "/UserModelGroup/DeleteUserModelGroupMapping",
  GET_USER_MODEL_GROUP_MAPPINGS_BY_MODEL_GROUP_ID:
    "/UserModelGroup/GetUserModelGroupMappingsByModelId"
};
